var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetodologyNumber1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 52,
    viewBox: "0 0 28 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0097 0.636719C22.0848 0.636719 27.0909 5.5616 27.0909 11.6367V42.864C27.0909 47.458 23.3667 51.1822 18.7727 51.1822C14.1787 51.1822 10.4545 47.458 10.4545 42.864V23.7281C10.4545 21.0453 7.52957 19.3867 5.22727 20.7639C2.92498 22.1412 0 20.4826 0 17.7998V12.2251C0 9.92058 1.19931 7.78214 3.16571 6.58045L10.2509 2.25062C11.978 1.19518 13.9856 0.636719 16.0097 0.636719ZM12.1312 14.3034C12.1643 14.2836 12.2022 14.2731 12.2409 14.2731C12.3589 14.2731 12.4545 14.3688 12.4545 14.4868V42.864C12.4545 46.3534 15.2833 49.1822 18.7727 49.1822C22.2622 49.1822 25.0909 46.3534 25.0909 42.864V11.7179C25.0909 6.70252 21.0251 2.63672 16.0097 2.63672C14.3387 2.63672 12.7001 3.09776 11.2743 3.9691L4.20862 8.28701C2.83672 9.12539 2 10.6173 2 12.2251C2 15.8098 5.90828 18.026 8.98454 16.1857L12.1312 14.3034Z",
    fill: "#11A0DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetodologyNumber1);
export default __webpack_public_path__ + "static/media/metodology-number1.d9d7808b83f29fcecd0b0a0451a122c1.svg";
export { ForwardRef as ReactComponent };